export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/vitals-parameters`,
        name: `${prefix}.vitals-parameters.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.vitals-parameters.index`,
                PageDescription: "Vitals parameter Listing/Create",
            },
        },
    },
];